import { useCallback, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { filterByProperties, isValidCpf, maskCpf, sortByProperty } from '@ibk/shared-utils';
import { useCnpjAlphanumeric } from '../useCnpjAlphanumeric';
const COMPANY_NAME = 'companyName';
const DOCUMENT_NUMBER = 'documentNumber';
const ACCOUNT_NUMBER = 'accountNumber';
const BRANCH_NUMBER = 'branchNumber';
const FIRST_NAME = 'firstName';
const LAST_NAME = 'lastName';
export function useAccountSelector(currentAccount, availableAccounts) {
    const { t } = useTranslation();
    const { isValidCnpj, maskCnpj } = useCnpjAlphanumeric();
    const [accounts, setAccounts] = useState(sortByProperty(availableAccounts ?? [], COMPANY_NAME, currentAccount));
    const [selectedAccount, setSelectedAccount] = useState(currentAccount);
    const formatAccountAndAgency = useCallback((account) => {
        if (!account.branchNumber && !account.accountNumber)
            return t('account-selector.without-account');
        if (account.branchNumber && account.accountNumber)
            return `${account.branchNumber} | ${account.accountNumber}`;
        return account.branchNumber ?? account.accountNumber;
    }, [t]);
    const formatDocument = useCallback((account) => {
        if (isValidCpf(account.documentNumber))
            return maskCpf(account.documentNumber);
        if (isValidCnpj(account.documentNumber))
            return maskCnpj(account.documentNumber);
    }, []);
    const isAccountSelected = useCallback((account) => !!selectedAccount && JSON.stringify(account) === JSON.stringify(selectedAccount), [selectedAccount]);
    const filterAccounts = useCallback((search) => {
        if (!search) {
            setAccounts(sortByProperty(availableAccounts ?? [], COMPANY_NAME, selectedAccount));
        }
        else {
            setAccounts(filterByProperties(sortByProperty(availableAccounts ?? [], COMPANY_NAME, selectedAccount), [COMPANY_NAME, DOCUMENT_NUMBER, ACCOUNT_NUMBER, BRANCH_NUMBER, FIRST_NAME, LAST_NAME], search));
        }
    }, [selectedAccount, availableAccounts]);
    return {
        selectedAccount,
        setSelectedAccount,
        accounts,
        setAccounts,
        filterAccounts,
        isAccountSelected,
        formatAccountAndAgency,
        formatDocument,
    };
}
